<template>
  <div class="page">
    <div class="navbar">
      <h1>数据记录</h1>
    </div>

    <div class="searchbar">
      <div class="search-in">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
          <circle cx="11" cy="11" r="7"/>
          <path d="M20 20l-3.5-3.5"/>
        </svg>
        <input v-model="keyword" placeholder="姓名 / 体检号 / 项目名称" @keyup.enter="onSearch"/>
        <span class="clear" :class="{ hidden: !keyword }" @click="clearKeyword">×</span>
        <button type="button" class="search-go" @click="onSearch">搜索</button>
      </div>
      <button class="filter-btn" :class="{ on: filterActive }" @click="showFilter = true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <path d="M3 6h18M7 12h10M10 18h4"/>
        </svg>
        <span v-if="filterActive">已筛选</span>
        <span v-else>筛选</span>
        <i class="dot" v-if="filterActive"></i>
      </button>
    </div>

    <div class="tabs">
      <div
        v-for="t in tabs"
        :key="t.key"
        class="tab"
        :class="{ active: currentStatus === t.key }"
        @click="selectStatus(t.key)"
      >
        {{ t.label }}
      </div>
    </div>

    <div class="projbar" v-if="projectName">
      <span class="nm">当前项目：{{ projectName }}</span>
      <span class="x" @click="clearProject">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </span>
    </div>

    <div class="scroll page-pad">
      <div v-if="loading && current_page === 1" class="m-loading"><span class="spin"></span><p>加载中…</p></div>
      <template v-if="!loading || current_page > 1">
      <div v-if="orders.length === 0" class="empty">
        <svg viewBox="0 0 120 120" fill="none">
          <rect x="18" y="26" width="84" height="74" rx="8" fill="#eef1f5"/>
          <rect x="30" y="14" width="60" height="20" rx="6" fill="#dfe4ea"/>
          <rect x="32" y="46" width="42" height="6" rx="3" fill="#d9dfe6"/>
          <rect x="32" y="62" width="56" height="6" rx="3" fill="#e4e9ee"/>
          <rect x="32" y="78" width="34" height="6" rx="3" fill="#e4e9ee"/>
        </svg>
        <p>暂无符合条件的订单</p>
      </div>

      <div class="card" v-for="(o, index) in orders" :key="o.id + '_' + index">
        <div class="card-hd">
          <div class="proj">{{ o.projName }}</div>
          <span class="tag" :style="{ color: statusColor(o.status), background: statusBg(o.status) }">
            {{ statusLabel(o.status) }}
          </span>
        </div>
        <div class="codes">
          <div class="person">
            <span class="nm">{{ o.name }}</span>
            <span class="gd" :class="o.gender === '女' ? 'gd-f' : 'gd-m'">{{ o.gender }}</span>
            <span class="ag">{{ o.age }}岁</span>
            <span class="ph"><i class="ph-l">手机号</i>{{ o.phone }}</span>
          </div>
          <div class="divider"></div>
          <div class="code-item"><span class="cl">客户编码</span><span class="cv copyable" @click.stop="copyExamNo(o)">{{ o.examNo }}<svg class="cp-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg></span></div>
          <div class="code-item" v-if="o.entryTime"><span class="cl">录入时间</span><span class="cv">{{ o.entryTime }}</span></div>
          <div class="code-item"><span class="cl">识别码</span><span class="cv">{{ o.code }}</span></div>
        </div>

        <div class="extra" v-if="o.status === '400'" :style="{ background: levelBg(o) }">
          <span class="lv" :style="{ color: levelColor(o) }"><i
            :style="{ background: levelColor(o) }"></i>报告 {{ (o.report && o.report.level) }}级</span>
          <span class="tm">报告时间 <b>{{ o.reportTime }}</b></span>
        </div>

        <div class="acts">
          <template v-if="o.status === '0'">
            <button class="btn" @click="openEdit(o)">修改资料</button>
            <button class="btn danger" @click="askDelete(o)">删除订单</button>
          </template>
          <button class="btn primary" v-else-if="o.status  === '400'" @click="viewReport(o)">查看报告</button>
          <button class="btn danger" v-else-if="o.status === '5000'" @click="openReject(o)" :disabled="loadingReject">驳回日志</button>
        </div>
      </div>

      <div v-if="orders.length > 0" class="loadend">
        <span v-if="finished">共 {{ page_total }} 条，已全部加载</span>
        <template v-else-if="loading && current_page > 1">
          <span class="spin-load"></span> 加载中…
        </template>
        <template v-else>
          <span class="load-hint">上拉加载更多</span>
        </template>
      </div>
      </template>
    </div>

    <transition name="slide-up">
      <div v-if="showFilter" class="filter-mask" @click.self="showFilter = false">
        <div class="filter-panel">
          <div class="filter-head">
            <span>筛选条件</span>
            <i class="ico-close" @click="showFilter = false">×</i>
          </div>
          <div class="filter-body">
            <div class="fld">
              <label>时间类型</label>
              <div class="seg">
                <button :class="{ on: draftTimeType === 'entry' }" @click="draftTimeType = 'entry'">录入时间</button>
                <button :class="{ on: draftTimeType === 'report' }" @click="draftTimeType = 'report'">报告时间</button>
              </div>
            </div>
            <div class="fld">
              <label>时间范围</label>
              <div class="quick">
                <button v-for="q in quickRanges" :key="q.key" :class="{ on: rangeKey === q.key }"
                        @click="applyQuick(q.key)">{{ q.label }}
                </button>
              </div>
              <div class="date-row">
                <div class="date-field" :class="{ on: draftStart }" @click="openDatePicker('start')">
                  <span class="ph" v-if="!draftStart"><i class="el-icon-date"></i>开始时间</span>
                  <span class="val" v-else>{{ formatDateLocal(new Date(draftStart)) }}</span>
                </div>
                <span class="date-sep">-</span>
                <div class="date-field" :class="{ on: draftEnd }" @click="openDatePicker('end')">
                  <span class="ph" v-if="!draftEnd"><i class="el-icon-date"></i>结束时间</span>
                  <span class="val" v-else>{{ formatDateLocal(new Date(draftEnd)) }}</span>
                </div>
              </div>
              <div v-if="rangeErr" class="f-err">{{ rangeErr }}</div>
            </div>
            <div class="fld">
              <label>报告级别</label>
              <div class="chips">
                <button
                  v-for="lv in levelOptions"
                  :key="lv.key"
                  class="chip"
                  :class="{ on: draftLevel === lv.key }"
                  @click="draftLevel = lv.key"
                >{{ lv.label }}
                </button>
              </div>
            </div>
            <div class="fld">
              <label>订单状态</label>
              <div class="chips">
                <button
                  v-for="t in [{ key: 'all', label: '全部' }, ...tabs.slice(1)]"
                  :key="t.key"
                  class="chip"
                  :class="{ on: draftStatus === t.key }"
                  @click="draftStatus = t.key"
                >{{ t.label }}
                </button>
              </div>
            </div>
          </div>
          <div class="filter-foot">
            <button class="btn ghost" @click="resetDraft">重置</button>
            <button class="btn primary" @click="applyFilter">确定</button>
          </div>
        </div>
      </div>
    </transition>

    <m-date-picker
      v-model="datePickerValue"
      :visible.sync="showDatePicker"
      :title="datePickerTitle"
      :min-date="datePickerMin"
      :max-date="datePickerMax"
      @change="onDateConfirm"
    />

    <transition name="slide-up">
      <div v-if="showEdit" class="edit-mask" @click.self="closeEdit">
        <div class="edit-panel">
          <div class="edit-head">
            <span>修改订单基础信息</span>
            <i class="ico-close" @click="closeEdit">×</i>
          </div>
          <div class="edit-body">
            <div class="fld">
              <label>项目名称</label>
              <div class="pv">{{ editForm.projName }}</div>
            </div>
            <div class="fld" :class="{ err: editErrors.name }">
              <label>姓名 <em>*</em></label>
              <div class="in">
                <input type="text" v-model="editForm.name" maxlength="20" placeholder="请输入姓名">
              </div>
              <div class="msg">{{ editErrors.name }}</div>
            </div>
            <div class="fld">
              <label>性别 <em>*</em></label>
              <div class="seg">
                <button type="button" :class="{ on: editForm.gender === '男' }" @click="editForm.gender = '男'">男</button>
                <button type="button" :class="{ on: editForm.gender === '女' }" @click="editForm.gender = '女'">女</button>
              </div>
            </div>
            <div class="fld" :class="{ err: editErrors.age }">
              <label>年龄 <em>*</em></label>
              <div class="in">
                <input type="number" v-model="editForm.age" placeholder="请输入年龄">
              </div>
              <div class="msg">{{ editErrors.age }}</div>
            </div>
            <div class="fld" :class="{ err: editErrors.phone }">
              <label>手机号 <em>*</em></label>
              <div class="in">
                <input type="tel" v-model="editForm.phone" maxlength="11" placeholder="请输入11位手机号">
              </div>
              <div class="msg">{{ editErrors.phone }}</div>
            </div>
            <div class="fld" :class="{ err: editErrors.code }">
              <label>识别码</label>
              <div class="in">
                <input type="text" v-model="editForm.code" maxlength="18" placeholder="请输入识别码">
              </div>
              <div class="msg">{{ editErrors.code }}</div>
            </div>
          </div>
          <div class="edit-foot">
            <button class="btn ghost" @click="closeEdit" :disabled="saving">取消</button>
            <button class="btn primary" @click="saveEdit" :disabled="saving">保存</button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="slide-up">
      <div v-if="showReject" class="rj-mask" @click.self="showReject = false">
        <div class="rj-panel">
          <div class="rj-head">
            <span>驳回日志</span>
            <i class="ico-close" @click="showReject = false">×</i>
          </div>
          <div class="rj-body">
            <div v-if="rejectLogs.length === 0" class="rj-empty">暂无驳回记录</div>
            <template v-else>
              <div class="rj-cap">共 {{ rejectLogs.length }} 条驳回记录</div>
              <div class="rj-log" v-for="(l, i) in rejectLogs" :key="i">
                <div class="rj-log-hd">
                  <span class="rj-idx">第 {{ i + 1 }} 次驳回</span>
                  <span class="rj-time">{{ l.time }}</span>
                </div>
                <div class="rj-reason">
                  <span class="k">原因</span>
                  <div class="rj-box">{{ l.reason }}</div>
                </div>
              </div>
            </template>
          </div>
          <div class="rj-foot">
            <button class="btn primary" @click="showReject = false">我知道了</button>
          </div>
        </div>
      </div>
    </transition>
    <m-tab-bar/>

    <m-confirm
      :visible.sync="showDelete"
      title="删除订单"
      :content="deleteTip"
      okText="确认删除"
      cancelText="取消"
      :ok-disabled="deleting"
      @ok="doDelete"
    />
  </div>
</template>

<script>
import MTabBar from './MTabBar.vue';
import MConfirm from './MConfirm.vue';
import MDatePicker from './MDatePicker.vue';
import mobileRem from '@/commonJs/mobileRem';
import ApiService from '@/service/ApiService';
import pub from '@/service/public';


export default {
  name: 'MOrder',
  components: {
    MTabBar,
    MConfirm,
    MDatePicker
  },
  mixins: [mobileRem],
  data() {
    return {
      keyword: '',
      showFilter: false,
      showDelete: false,
      deleteTip: '',
      pendingOrder: null,
      draftStart: '',
      draftEnd: '',
      currentStart: '',
      currentEnd: '',
      currentTimeType: 'entry',
      currentLevel: '',
      draftStatus: 'all',
      draftTimeType: 'entry',
      draftLevel: '',
      rangeKey: '',
      rangeErr: '',
      quickRanges: [
        {key: '7d', label: '近7天'},
        {key: '30d', label: '近30天'},
        {key: '90d', label: '近90天'}
      ],
      showDatePicker: false,
      datePickerTitle: '起始时间',
      datePickerField: 'start',
      datePickerValue: '',
      datePickerMin: null,
      datePickerMax: null,
      levelOptions: [
        {key: '', label: '全部'},
        {key: '1', label: '1 级'},
        {key: '2', label: '2 级'},
        {key: '3', label: '3 级'}
      ],
      tabs: [],

      loading: false,
      finished: false,
      currentStatus: 'all',
      current_page: 1,
      page_limit: 20,
      page_total: 0,
      orders: [],
      projectId: '',
      projectName: '',
      showReject: false,
      rejectLogs: [],
      rejectName: '',
      showEdit: false,
      editingOrder: null,
      editForm: {
        projName: '',
        name: '',
        gender: '男',
        age: '',
        phone: '',
        code: ''
      },
      editErrors: {
        name: '',
        age: '',
        phone: '',
        code: ''
      },
      saving: false,
      deleting: false,
      loadingReject: false
    }
  },
  computed: {
    filterActive() {
      return !!(this.currentStart || this.currentEnd ||
        (this.currentStatus && this.currentStatus !== 'all') ||
        (this.currentTimeType && this.currentTimeType !== 'entry') ||
        this.currentLevel)
    }
  },
  watch: {
    showFilter(v) {
      if (v) {
        // 打开抽屉时同步当前已生效的筛选到 draft
        this.draftStatus = this.currentStatus
        this.draftStart = this.currentStart
        this.draftEnd = this.currentEnd
        this.draftTimeType = this.currentTimeType
        this.draftLevel = this.currentLevel
        this.rangeKey = ''
        this.rangeErr = ''
      }
    },
    '$route'() {
      this.applyRouteQuery()
      this.loadData()
    }
  },
  mounted() {
    this.initConstOptions()
    this.applyRouteQuery()
    this.loadData()
    this.bindScrollEvent()
  },
  beforeDestroy() {
    this.unbindScrollEvent()
  },
  methods: {
    initConstOptions() {
      let constData = pub.getConst()
      if (constData) {
        // 订单状态枚举 - 动态加载
        if (constData.orderState && Array.isArray(constData.orderState)) {
          this.tabs = [
            {key: 'all', label: '全部'},
            ...constData.orderState.map(item => ({
              key: String(item.value),
              label: item.name,
              color: (item.attr && item.attr.color) || '#9097a6',
              bg: (item.attr && item.attr.bg) || '#f1f3f6'
            }))
          ]
        }
        // 报告级别枚举
        if (constData.rptLevel && constData.rptLevel.heart) {
          this.levelOptions = [
            {key: '', label: '全部'},
            ...constData.rptLevel.heart.map(item => ({
              key: String(item.value),
              label: item.name
            }))
          ]
        }
      }
    },
    bindScrollEvent() {
      this.scrollEl = this.$el.querySelector('.scroll')
      if (!this.scrollEl) return
      this.scrollHandler = this.handleScroll.bind(this)
      this.scrollEl.addEventListener('scroll', this.scrollHandler, { passive: true })
    },
    unbindScrollEvent() {
      if (this.scrollEl && this.scrollHandler) {
        this.scrollEl.removeEventListener('scroll', this.scrollHandler)
        this.scrollEl = null
      }
    },
    // 与原型一致：滚动到底部前 40px 自动加载下一页
    handleScroll() {
      if (this.loading || this.finished) return
      const el = this.scrollEl
      if (!el) return
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
        this.loadNextPage()
      }
    },
    loadNextPage() {
      if (this.loading || this.finished) return
      this.current_page++
      this.loadData()
    },
    // 首页数据不足一屏时不会触发 scroll，这里自动补一页（原型每页 6 条卡片较高不会出现该情况）
    autoFillIfNeeded() {
      this.$nextTick(() => {
        const el = this.scrollEl || this.$el.querySelector('.scroll')
        if (!el || this.loading || this.finished) return
        if (el.scrollHeight <= el.clientHeight + 40) this.loadNextPage()
      })
    },
    // 增删改后回到第一页重新加载（原型 load(true)）
    reload() {
      this.current_page = 1
      this.loadData()
    },
    onSearch() {
      this.current_page = 1
      this.loadData()
    },
    selectStatus(s) {
      if (s === this.currentStatus) return
      this.currentStatus = s
      this.current_page = 1
      this.loadData()
    },
    applyQuick(key) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      let start = null, end = null
      const days = { '7d': 7, '30d': 30, '90d': 90 }[key]
      if (days) {
        end = new Date(today)
        start = new Date(today.getTime() - (days - 1) * 86400000)
      }
      this.draftStart = start.getTime()
      this.draftEnd = end.getTime()
      this.rangeKey = key
      this.rangeErr = ''
    },
    openDatePicker(field) {
      this.datePickerField = field
      this.datePickerTitle = field === 'start' ? '开始时间' : '结束时间'
      this.datePickerValue = field === 'start' ? this.draftStart : this.draftEnd
      // 约束联动：若对方时间已选，则限制当前选择器的可选范围，无需用户手动纠正
      if (field === 'start') {
        // 先选结束时间后选开始时间：开始时间最大可等于结束时间的当天
        this.datePickerMax = this.draftEnd ? this.endOfDay(this.draftEnd) : this.endOfDay(Date.now())
        this.datePickerMin = null
      } else {
        // 先选开始时间后选结束时间：结束时间最小可等于开始时间的当天
        this.datePickerMin = this.draftStart ? this.startOfDay(this.draftStart) : null
        this.datePickerMax = this.endOfDay(Date.now())
      }
      this.showDatePicker = true
      this.rangeKey = 'custom'
      this.rangeErr = ''
    },
    startOfDay(ts) {
      const d = new Date(Number(ts))
      d.setHours(0, 0, 0, 0)
      return d
    },
    endOfDay(ts) {
      const d = new Date(Number(ts))
      d.setHours(0, 0, 0, 0)
      return d
    },
    onDateConfirm(ts) {
      if (!ts) return
      // 选择时各自保留真实值，不再自动纠正另一个时间（避免悄悄改动用户已选项）
      if (this.datePickerField === 'start') {
        this.draftStart = ts
      } else {
        this.draftEnd = ts
      }
      this.rangeKey = 'custom'
    },
    formatDateLocal(d) {
      const pad = n => n < 10 ? '0' + n : '' + n
      return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
    },
    applyFilter() {
      // 过滤条件：开始时间不能大于结束时间（两个都填了才校验）
      if (this.draftStart && this.draftEnd && new Date(this.draftStart) > new Date(this.draftEnd)) {
        this.rangeErr = '开始时间不能大于结束时间'
        return
      }
      // 保存当前筛选条件
      this.currentStatus = this.draftStatus
      this.currentStart = this.draftStart
      this.currentEnd = this.draftEnd
      this.currentTimeType = this.draftTimeType
      this.currentLevel = this.draftLevel
      this.current_page = 1
      this.loadData()
      this.showFilter = false
    },
    resetDraft() {
      this.draftStart = ''
      this.draftEnd = ''
      this.draftStatus = 'all'
      this.draftTimeType = 'entry'
      this.draftLevel = ''
      this.rangeKey = ''
      this.rangeErr = ''
    },
    resetQuery() {
      this.keyword = ''
      this.resetDraft()
      this.currentStatus = 'all'
      this.current_page = 1
      const q = this.$route.query || {}
      if (Object.keys(q).length) {
        // 清掉 URL 上的筛选参数，$route watcher 会重置并重新加载
        this.$router.replace('/m/order')
      } else {
        this.loadData()
      }
    },
    clearKeyword() {
      this.keyword = ''
      this.onSearch()
    },
    clearProject() {
      this.projectId = ''
      this.projectName = ''
      this.$router.replace('/m/order')
    },
    applyRouteQuery() {
      const q = this.$route.query || {}
      // 路由查询为筛选的事实来源：先重置，再按参数应用（无参数 = 全部重置）
      this.projectId = q.pid || ''
      this.projectName = q.pname ? decodeURIComponent(q.pname) : ''
      this.currentStatus = 'all'
      this.draftStart = ''
      this.draftEnd = ''
      this.draftTimeType = 'entry'
      // 同步清空"已应用"的筛选条件，避免路由切换后旧日期/级别/状态残留导致请求与界面不一致
      this.currentStart = ''
      this.currentEnd = ''
      this.currentLevel = ''
      this.currentTimeType = 'entry'
      this.current_page = 1
      // 状态（首页今日数据卡带入）
      if (q.status && this.tabs.some(t => t.key === q.status)) {
        this.currentStatus = q.status
      }
      // 日期范围：today=1 表示当日；也可直接传 tstart/tend/ttype
      const timeType = q.ttype === 'report' ? 'report' : 'entry'
      if (q.today === '1') {
        const td = new Date()
        td.setHours(0, 0, 0, 0)
        this.draftStart = td.getTime()
        this.draftEnd = td.getTime()
        // 同步"已应用"的筛选状态，时间筛选才能真正参与请求（与 PC 选同一天行为一致）
        this.currentStart = td.getTime()
        this.currentEnd = td.getTime()
      } else if (q.tstart || q.tend) {
        const s = q.tstart ? new Date(q.tstart).getTime() : ''
        const e = q.tend ? new Date(q.tend).getTime() : ''
        this.draftStart = s
        this.draftEnd = e
        this.currentStart = s
        this.currentEnd = e
      }
      this.draftTimeType = timeType
      this.currentTimeType = timeType
    },
    // 跳转报告详情页，传递订单UUID
    viewReport(o) {
      const orderUUID = o.id;
      this.$router.push('/m/report?id=' + encodeURIComponent(orderUUID || ''))
    },
    openEdit(o) {
      this.editingOrder = o
      this.editForm = {
        projName: o.projName || '',
        name: o.name || '',
        gender: o.gender || '男',
        age: o.age === undefined || o.age === null ? '' : String(o.age),
        phone: o.phone || '',
        code: o.code || ''
      }
      this.editErrors = {name: '', age: '', phone: '', code: ''}
      this.showEdit = true
    },
    closeEdit() {
      this.showEdit = false
      this.editingOrder = null
    },
    saveEdit() {
      const e = {name: '', age: '', phone: '', code: ''}
      const name = (this.editForm.name || '').trim()
      const age = String(this.editForm.age).trim()
      const phone = (this.editForm.phone || '').trim()
      const code = (this.editForm.code || '').trim()
      let ok = true

      if (!name) {
        e.name = '请输入姓名'
        ok = false
      } else if (name.length < 2) {
        e.name = '姓名至少 2 个字符'
        ok = false
      }

      if (!age) {
        e.age = '请输入年龄'
        ok = false
      } else if (!/^\d{1,3}$/.test(age) || +age < 1 || +age > 120) {
        e.age = '年龄需为 1-120 的整数'
        ok = false
      }

      if (!phone) {
        e.phone = '请输入手机号'
        ok = false
      } else if (!/^1[3-9]\d{9}$/.test(phone)) {
        e.phone = '手机号格式不正确'
        ok = false
      }

      this.editErrors = e
      if (!ok) return

      const o = this.editingOrder
      if (!o) return

      this.saving = true
      // 传参与 PC 端 RecordList submitUpdateOrderHandle 一致，仅 agent=mobile
      const params = {
        page: { number: 0, limit: 1 },
        keyWord: [],
        parms: {
          orderUuid: o.id,
          customerName: name,
          customerGender: this.editForm.gender,
          customerMobile: phone,
          checkCode: code,
          customerAge: +age
        }
      }
      ApiService.updateHeartOrder(params, 'mobile').then(res => {
        if (res && res.code === pub.backCode.SUCCESS) {
          this.closeEdit()
          pub.tip(this.editForm.name + '数据信息已更新', 'success', 2000)
          this.reload()
        } else {
          pub.analysisReturnCode(res, null)
        }
      }).catch(err => {
        pub.tip('更新失败', 'error')
        console.error('更新订单失败：', err)
      }).finally(() => {
        this.saving = false
      })
    },
    openReject(o) {
      if (this.loadingReject) return
      this.loadingReject = true
      this.rejectLogs = []
      this.rejectName = o.name
      this.showReject = true

      // 传参与 PC 端 RecordList showReasonDiaHandle 一致，仅 agent=mobile
      const params = {
        page: { number: 0, limit: 100 },
        keyWord: [],
        parms: {
          orderUuid: o.id,
          checkupCode: o.code
        }
      }
      ApiService.BackReason(params, 'mobile').then(res => {
        if (res && res.code === pub.backCode.SUCCESS) {
          this.rejectLogs = ((res.data && res.data.pageList) || []).map(r => ({
            time: this.fmtDateTime(r.backTime),
            reason: r.backReason
          }))
        } else {
          pub.analysisReturnCode(res, null)
        }
      }).catch(err => {
        console.error('获取驳回日志失败：', err)
      }).finally(() => {
        this.loadingReject = false
      })
    },
    askDelete(o) {
      this.pendingOrder = o
      this.deleteTip = '确认删除「' + o.name + '」的订单 ' + o.examNo + ' 吗？删除后数据不可恢复。'
      this.showDelete = true
    },
    doDelete() {
      if (this.deleting) return
      const o = this.pendingOrder
      if (!o) return
      this.deleting = true

      // 传参与 PC 端 RecordList delOrderList 一致，仅 agent=mobile
      const params = {
        page: { number: 0, limit: 1 },
        keyWord: [],
        parms: {
          orderUuid: o.id,
          checkupCode: o.code
        }
      }
      ApiService.delHeartOrder(params, 'mobile').then(res => {
        if (res && res.code === pub.backCode.SUCCESS) {
          this.pendingOrder = null
          pub.tip('订单已删除', 'success', 1600)
          this.reload()
        } else {
          pub.analysisReturnCode(res, null)
        }
      }).catch(err => {
        this.pendingOrder = null
        pub.tip('删除失败', 'error')
        console.error('删除订单失败：', err)
      }).finally(() => {
        this.deleting = false
      })
    },
    loadData() {
      if (this.loading) return
      this.loading = true
      this.finished = false
      const isReset = this.current_page === 1
      const params = this.buildQueryParams()
      
      ApiService.HeartRecordList(params, 'mobile').then(res => {
        this.loading = false
        if (res && res.code === pub.backCode.SUCCESS) {
          const list = (res.data && res.data.pageList) || []
          const mappedList = list.map(p => this.mapOrder(p))
          if (isReset) {
            // 第一页：整体替换（原型 load(true) 里 S.list = []）
            this.orders = mappedList
            // 仅第一页后台才会返回总数，记录后供后续页复用
            const total = res.data && res.data.itemTotal
            const hasTotal = typeof total === 'number' && total >= 0
            if (hasTotal) this.page_total = total
          } else {
            // 后续页：追加（原型 S.list = all.slice(0, end) 的等价效果）
            this.orders = this.orders.concat(mappedList)
          }
          // 判断是否到底：
          // 1) 后台返回了总数 → 总页数 maxPage = ceil(total/limit)，页码到达 maxPage 即到底
          // 2) 未返回总数（异常）→ 本页不满一页即视为到底（原型 hasMore = end < all.length）
          if (this.page_total > 0) {
            const maxPage = Math.ceil(this.page_total / this.page_limit)
            this.finished = this.current_page >= maxPage
          } else {
            this.finished = mappedList.length < this.page_limit
            this.page_total = this.finished ? this.orders.length : 0
          }
          if (!this.finished) this.autoFillIfNeeded()
        } else {
          // 统一走公共返回码处理：token 失效等场景会自动提示并跳转登录页
          pub.analysisReturnCode(res, null)
        }
      }).catch(err => {
        this.loading = false
        // 加载更多失败：回退页码，保持「上拉加载更多」，再次上拉可重试同一页
        if (this.current_page > 1) {
          this.current_page--
        } else {
          this.finished = true
        }
        pub.tip('加载失败，请重试', 'error')
        console.error('订单列表加载失败：', err)
      })
    },
    /**
     * 构造请求参数（与 PC 端 RecordList.vue buildQueryParams 一致）
     */
    buildQueryParams() {
      const timeFrame = this.buildTimeFrameParams()
      const status = this.mapStatusToNumber(this.currentStatus)
      const level = this.currentLevel ? Number(this.currentLevel) : -1
      const kw = (this.keyword || '').trim()
      // 解析关键词：支持 姓名/体检号/项目名称 搜索
      let keyWord = []
      let projectName = this.projectName
      if (kw) {
        // 简单处理：关键词作为 customerName 传递（与 PC 端一致）
        keyWord.push(kw)
      }
      return {
        page: { number: this.current_page - 1, limit: this.page_limit },
        keyWord: keyWord,
        parms: {
          timeFrame: timeFrame,
          projectName: projectName,
          customerName: '',
          checkupCode: '',
          level: level,
          status: status
        }
      }
    },
    /**
     * 构造 timeFrame 数组（与 PC 端 RecordList.vue buildTimeFrameParams 一致）
     * timeType: 5=录入时间 10=报告时间
     */
    buildTimeFrameParams() {
      let startTime = 0, endTime = 0
      if (this.currentStart) {
        // 确保开始时间为当天的 0:00:00
        const startDate = new Date(this.currentStart)
        startDate.setHours(0, 0, 0, 0)
        startTime = Math.floor(startDate.getTime() / 1000)
      }
      if (this.currentEnd) {
        // 结束时间为当天的 0:00:00
        const endDate = new Date(this.currentEnd)
        endDate.setHours(0, 0, 0, 0)
        endTime = Math.floor(endDate.getTime() / 1000)
      }
      const timeFrames = []
      if (startTime || endTime) {
        timeFrames.push({
          timeType: this.currentTimeType === 'report' ? 10 : 5,
          startTime: startTime,
          endTime: endTime
        })
      }
      return timeFrames
    },
    /**
     * mobile status 字符串 → PC status 数字
     */
    mapStatusToNumber(key) {
      if (!key || key === 'all') return -1
      return Number(key)
    },
    /**
     * PC status 数字 → mobile status 字符串
     */
    mapStatusToKey(value) {
      const v = Number(value)
      return String(v)
    },
    /**
     * PC 后端返回的订单 record → mobile 端结构
     */
    mapOrder(p) {
      return {
        id: p.orderUuid,
        projName: p.projectName || '',
        examNo: p.checkupCode || '',
        code: p.checkCode || '',
        name: p.customerName || '',
        gender: p.customerGender || '',
        age: p.customerAge,
        phone: p.customerMobile || '',
        entryTime: this.fmtDateTime(p.receiveTime),
        reportTime: p.reportTime ? this.fmtDateTime(p.reportTime) : '',
        status: this.mapStatusToKey(p.status),
        report: (p.level !== undefined && p.level !== null && p.level !== '') ? {
          level: String(p.level),
          levelText: this.getLevelText(p.level)
        } : null,
        mergeReportFileName: p.mergeReportFileName || ''
      }
    },
    getLevelText(value) {
      const constData = pub.getConst()
      if (constData && constData.rptLevel && constData.rptLevel.heart) {
        const item = constData.rptLevel.heart.find(i => String(i.value) === String(value))
        if (item) return item.name
      }
      return String(value) + '级'
    },
    /**
     * 秒级时间戳 → 'YYYY-MM-DD HH:mm:ss'
     */
    fmtDateTime(ts) {
      if (ts === undefined || ts === null || ts === 0 || ts === '0') return ''
      const d = new Date(Number(ts) * 1000)
      if (isNaN(d.getTime())) return ''
      const p = n => n < 10 ? '0' + n : '' + n
      return [d.getFullYear(), p(d.getMonth() + 1), p(d.getDate())].join('-') + ' ' +
        [p(d.getHours()), p(d.getMinutes()), p(d.getSeconds())].join(':')
    },
    // 点击复制客户编码（兼容 http 环境：优先 clipboard API，失败降级 execCommand）
    copyExamNo(o) {
      const text = String(o.examNo || '')
      if (!text) return
      const done = () => pub.tip('客户编码已复制', 'success', 1600)
      const fallback = () => {
        try {
          const ta = document.createElement('textarea')
          ta.value = text
          ta.setAttribute('readonly', '')
          ta.style.position = 'fixed'
          ta.style.opacity = '0'
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
          done()
        } catch (e) {
          pub.tip('复制失败，请长按手动复制', 'error')
        }
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done).catch(fallback)
      } else {
        fallback()
      }
    },
    statusLabel(s) {
      const tab = this.tabs.find(t => t.key === String(s))
      return tab ? tab.label : s
    },
    statusColor(s) {
      const tab = this.tabs.find(t => t.key === String(s))
      if (tab && tab.color) return tab.color
      // 兜底：直接从 GetConst 订单状态取色，保证与 PC 同源
      const constData = pub.getConst()
      if (constData && constData.orderState) {
        const item = constData.orderState.find(i => String(i.value) === String(s))
        if (item && item.attr && item.attr.color) return item.attr.color
      }
      return '#9097a6'
    },
    // 背景取状态色的浅色调（比字色浅），与 PC 同一套取色来源
    statusBg(s) {
      return this.lighten(this.statusColor(s), 0.88)
    },
    levelColor(o) {
      // 报告级别同样取自 GetConst.rptLevel 的 attr.color，保持与 PC 一致
      const lv = (o.report && o.report.level)
      const constData = pub.getConst()
      if (constData && constData.rptLevel && constData.rptLevel.heart) {
        const item = constData.rptLevel.heart.find(i => String(i.value) === String(lv))
        if (item && item.attr && item.attr.color) return item.attr.color
      }
      const map = {'1': '#16b364', '2': '#ff8f1f', '3': '#f5544b'}
      return map[lv] || '#16b364'
    },
    levelBg(o) {
      return this.lighten(this.levelColor(o), 0.88)
    },
    // 将十六进制颜色按 whiteRatio 比例向白色混合，得到浅色调背景
    lighten(hex, whiteRatio = 0.88) {
      const h = String(hex || '').replace('#', '')
      if (h.length !== 6) return '#f1f3f6'
      const r = parseInt(h.substring(0, 2), 16)
      const g = parseInt(h.substring(2, 4), 16)
      const b = parseInt(h.substring(4, 6), 16)
      const mix = c => Math.round(c + (255 - c) * whiteRatio)
      return '#' + [mix(r), mix(g), mix(b)]
        .map(c => c.toString(16).padStart(2, '0')).join('')
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent
}

.page {
  --primary: #12b3a8;
  --primary-d: #0d9b91;
  --primary-l: #e8f8f6;
  --danger: #f5544b;
  --danger-l: #ffeeed;
  --warn: #ff8f1f;
  --warn-l: #fff5e6;
  --success: #16b364;
  --success-l: #e7f8ef;
  --t1: #14181f;
  --t2: #5b6472;
  --t3: #9aa4b2;
  --line: #eef0f4;
  --bg: #f4f6f8;
  --card: #fff;
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: var(--bg);
  display: flex;
  flex-direction: column
}

.navbar {
  height: 46px;
  flex: none;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: 0.5px solid rgba(0, 0, 0, .15)
}

.navbar h1 {
  font-size: 17px;
  font-weight: 600;
  color: var(--t1)
}

.navbar .nav-btn {
  position: absolute;
  right: 8px;
  top: 0;
  height: 46px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 14px;
  color: var(--t2);
  gap: 4px;
  cursor: pointer;
  background: none;
  border: none
}

.navbar .nav-btn .dot {
  position: absolute;
  top: 10px;
  right: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--danger)
}

/* 搜索条 */
.searchbar {
  flex: none;
  background: #fff;
  padding: 8px 12px 10px;
  display: flex;
  gap: 8px;
  align-items: center
}

.search-in {
  flex: 1;
  height: 36px;
  background: var(--bg);
  border-radius: 18px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 4px
}

.search-in svg {
  width: 15px;
  height: 15px;
  flex: none;
  opacity: .45
}

.search-in input {
  flex: 1;
  height: 100%;
  font-size: 14px;
  background: none
}

.search-in input::placeholder {
  color: var(--t3)
}

.search-in .clear {
  flex: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #c8ced9;
  color: #fff;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  cursor: pointer
}

/* 始终占位，仅隐藏符号：保证输入/不输入时输入框宽度一致，清除键不跳动 */
.search-in .clear.hidden {
  visibility: hidden;
  pointer-events: none
}

.search-in .search-go {
  padding: 0 13px;
  height: 27px;
  border-radius: 14px;
  background: var(--primary);
  color: #fff;
  font-size: 13px;
  flex: none;
  border: none;
}

.search-in .search-go:active {
  background: var(--primary-d)
}

.filter-btn {
  flex: none;
  width: 60px;
  height: 36px;
  padding: 0 2px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: var(--t2);
  position: relative;
  background: none;
  border: none;
  white-space: nowrap;
  justify-content: flex-start;
}

.filter-btn svg {
  width: 15px;
  height: 15px
}

.filter-btn.on {
  color: var(--primary);
  font-weight: 600
}

.filter-btn .dot {
  position: absolute;
  top: 6px;
  right: -2px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--danger)
}

/* 状态 Tab（胶囊样式，可横向滚动，常驻顶部） */
.tabs {
  flex: none;
  background: #fff;
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  padding: 10px 12px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  border-bottom: .5px solid var(--line)
}

.tabs::-webkit-scrollbar {
  display: none
}

.tab {
  flex: none;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  padding: 0 12px;
  border-radius: 16px;
  font-size: 13px;
  color: var(--t2);
  background: var(--bg);
  white-space: nowrap;
  transition: .15s;
  cursor: pointer;
  box-sizing: border-box
}

.tab.active {
  background: var(--primary);
  color: #fff;
  font-weight: 600
}

.tab .n {
  font-size: 11px;
  line-height: 1;
  padding: 1px 5px;
  border-radius: 8px;
  background: rgba(20, 24, 31, .07);
  color: var(--t2)
}

.tab.active .n {
  background: rgba(255, 255, 255, .28);
  color: #fff
}

/* 项目筛选条（首页/项目页带入） */
.projbar {
  flex: none;
  background: var(--primary-l);
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: var(--primary-d)
}

.projbar .nm {
  flex: 1;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.projbar .x {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(13, 155, 145, .15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  cursor: pointer
}

.projbar .x svg {
  width: 12px;
  height: 12px
}

/* 列表加载态 */
.m-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 90px 0;
  gap: 12px;
  color: var(--t3)
}

.m-loading .spin {
  width: 26px;
  height: 26px;
  border: 2.5px solid #d8dde5;
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin .7s linear infinite
}

.m-loading p {
  font-size: 13px
}

.loading-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  gap: 8px;
  color: var(--t3)
}

.loading-more .spin {
  width: 20px;
  height: 20px;
  border: 2px solid #d8dde5;
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin .7s linear infinite
}

.loading-more p {
  font-size: 12px
}

@keyframes spin {
  to {
    transform: rotate(360deg)
  }
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 70px 20px;
  text-align: center
}

.empty svg {
  width: 96px;
  height: 96px;
  opacity: .5
}
.empty p {
  color: var(--t3);
  font-size: 13.5px;
  margin-top: 12px
}

.scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(56px + env(safe-area-inset-bottom))
}

.page-pad {
  padding: 10px 12px 24px
}

/* 卡片 */
.card {
  background: var(--card);
  border-radius: 14px;
  padding: 13px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(20, 24, 31, .05);
  animation: in .25s ease both
}

@keyframes in {
  from {
    opacity: 0;
    transform: translateY(8px)
  }
}

.card-hd {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px
}

.proj {
  font-size: 15px;
  font-weight: 600;
  color: var(--t1);
  line-height: 1.35;
  flex: 1
}

.tag {
  flex: none;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 5px;
  font-weight: 600;
  white-space: nowrap;
  margin-top: 1px
}

.sub {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 7px;
  font-size: 11.5px;
  color: var(--t3);
  flex-wrap: wrap
}

.sub .mono {
  font-family: ui-monospace, Menlo, Consolas, monospace;
  letter-spacing: 0
}

.codes {
  margin-top: 9px;
  background: var(--bg);
  border-radius: 9px;
  padding: 9px 11px;
  display: flex;
  flex-direction: column;
  gap: 8px
}

.code-item {
  display: flex;
  align-items: baseline;
  gap: 9px;
  font-size: 12px;
  line-height: 1.4
}

.code-item .cl {
  flex: none;
  color: var(--t3);
  width: 60px;
  white-space: nowrap;
}

.code-item .cv {
  font-family: ui-monospace, Menlo, Consolas, monospace;
  font-size: 12.5px;
  color: var(--t1);
  letter-spacing: .3px;
  word-break: break-all
}

.code-item .cv.copyable {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent
}

.code-item .cv .cp-ico {
  flex: none;
  width: 12px;
  height: 12px;
  color: var(--t3)
}

.code-item .cv.copyable:active {
  opacity: .6
}

.divider {
  height: 1px;
  background: var(--line);
  margin: 10px 0
}

.codes .divider {
  margin: 2px -11px
}

.person {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--t1)
}

.person .nm {
  font-size: 15px
}

.person .gd {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px
}

.person .gd.gd-m {
  color: #3a7afe;
  background: #e4eeff
}

.person .gd.gd-f {
  color: #f0568f;
  background: #fde7f0
}

.person .ag {
  font-size: 13px;
  color: var(--t2)
}

.person .ph {
  margin-left: auto;
  font-size: 13px;
  color: var(--t2);
  font-family: ui-monospace, Menlo, Consolas, monospace;
  display: flex;
  align-items: center;
  gap: 4px
}

.person .ph-l {
  font-style: normal;
  font-size: 11.5px;
  color: var(--t3);
  font-family: inherit
}

.row {
  display: flex;
  align-items: center;
  font-size: 12.5px;
  color: var(--t3);
  margin-top: 7px;
  gap: 6px
}

.row .v {
  color: var(--t2)
}

.extra {
  margin-top: 10px;
  border-radius: 9px;
  padding: 9px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--success-l)
}

.extra .lv {
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 5px
}

.extra .lv i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block
}

.extra .tm {
  margin-left: auto;
  font-size: 12px;
  color: var(--t2)
}

.extra .tm b {
  font-weight: 600;
  color: var(--t1)
}

.acts {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 11px
}

.btn {
  height: 31px;
  padding: 0 15px;
  border-radius: 16px;
  font-size: 13px;
  border: 1px solid #dfe3ea;
  color: var(--t2);
  background: #fff;
  transition: .12s
}

.btn:active {
  transform: scale(.96)
}

.btn.primary {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
  font-weight: 600
}

.btn.danger {
  color: var(--danger);
  border-color: #f8cdc9
}

.btn.danger:active {
  background: var(--danger-l)
}

.btn.block {
  width: 100%;
  height: 46px;
  border-radius: 23px;
  font-size: 16px;
  border: none
}

.skeleton {
  padding: 0
}

.sk-card {
  height: 180px;
  background: linear-gradient(90deg, #f1f3f6 25%, #eef0f4 50%, #f1f3f6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
  border-radius: 14px;
  margin-bottom: 12px
}

@keyframes shimmer {
  0% {
    background-position: 200% 0
  }
  100% {
    background-position: -200% 0
  }
}

.loadend {
  text-align: center;
  color: var(--t3);
  font-size: 12px;
  padding: 14px 0 4px
}

.loadend .spin-load {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 2px solid #d8dde5;
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin .7s linear infinite;
  vertical-align: -2px;
  margin-right: 6px
}

.loadend .load-hint {
  display: inline-block;
  color: var(--t3);
  padding: 6px 0
}

.empty {
  padding: 70px 20px;
  text-align: center
}

.empty-icon {
  font-size: 48px;
  color: #cfd5de;
  margin-bottom: 12px
}

.empty-text {
  color: var(--t3);
  font-size: 13.5px;
  margin-top: 12px
}

.btn-link {
  background: transparent;
  border: 1px solid var(--primary);
  color: var(--primary);
  padding: 6px 16px;
  border-radius: 16px;
  font-size: 13px;
  cursor: pointer
}

/* 筛选抽屉 */
.filter-mask {
  position: fixed;
  inset: 0;
  background: rgba(12, 16, 22, .45);
  z-index: 100;
  display: flex;
  align-items: flex-end
}

.filter-panel {
  width: 100%;
  background: #fff;
  border-radius: 18px 18px 0 0;
  max-height: 86%;
  display: flex;
  flex-direction: column;
  padding-bottom: env(safe-area-inset-bottom)
}

.filter-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  position: relative
}

.ico-close {
  font-style: normal;
  font-size: 24px;
  color: var(--t3);
  cursor: pointer
}

.filter-body {
  padding: 4px 16px 8px;
  overflow-y: auto
}

.fld {
  margin-bottom: 18px
}

.fld > label {
  display: block;
  font-size: 13px;
  color: var(--t2);
  margin-bottom: 8px;
  font-weight: 500
}

.seg {
  display: flex;
  gap: 9px
}

.seg button {
  flex: 1;
  height: 44px;
  background: var(--bg);
  border-radius: 10px;
  font-size: 14.5px;
  color: var(--t2);
  border: 1px solid transparent;
  cursor: pointer
}

.seg button.on {
  background: var(--primary-l);
  border-color: var(--primary);
  color: var(--primary-d);
  font-weight: 600
}

.range {
  display: flex;
  align-items: center;
  gap: 8px
}

.range input {
  flex: 1;
  height: 36px;
  border: 1px solid #e0e4ec;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 13px;
  outline: none
}

.range span {
  color: var(--t3);
  font-size: 13px;
  flex: none
}

.quick {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px
}

.quick button {
  flex: 1 0 calc(33.333% - 6px);
  text-align: center;
  padding: 7px 0;
  font-size: 12.5px;
  background: var(--bg);
  border-radius: 8px;
  color: var(--t2);
  border: 1px solid transparent;
  cursor: pointer;
  min-width: 0
}

.quick button.on {
  background: var(--primary-l);
  color: var(--primary-d);
  font-weight: 600
}

.f-err {
  color: var(--danger);
  font-size: 12px;
  margin-top: 6px
}

.date-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px
}

.date-field {
  flex: 1;
  height: 40px;
  background: var(--bg);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  font-size: 14px;
  color: var(--t2);
  cursor: pointer;
  transition: .15s
}

.date-field .ph {
  color: var(--t3)
}

.date-field .ph i{
  padding-right:4px;
}

.date-field .val {
  color:  var(--primary-d);
  font-weight: 600
}

.date-field.on {
  background: #e8f8f6
}

.date-sep {
  color: var(--t3);
  font-size: 13px;
  flex: none
}

.chips {
  display: grid;
  grid-template-columns:repeat(4, 1fr);
  gap: 10px
}

.chip {
  padding: 10px 0;
  border-radius: 10px;
  font-size: 13px;
  background: var(--bg);
  color: var(--t2);
  border: 1px solid transparent;
  text-align: center;
  cursor: pointer
}

.chip.on {
  background: var(--primary-l);
  border-color: var(--primary);
  color: var(--primary-d);
  font-weight: 600
}

.filter-foot {
  display: flex;
  gap: 10px;
  padding: 10px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid var(--line)
}

.filter-foot .btn {
  flex: 1;
  height: 44px;
  border-radius: 22px;
  font-size: 15px
}

.filter-foot .btn.ghost {
  background: #fff;
  color: var(--t2);
  border-color: #e0e4ec
}

/* 编辑基础信息（空单）弹层 */
.edit-mask {
  position: fixed;
  inset: 0;
  background: rgba(12, 16, 22, .45);
  z-index: 100;
  display: flex;
  align-items: flex-end
}

.edit-panel {
  width: 100%;
  background: #fff;
  border-radius: 18px 18px 0 0;
  max-height: 86%;
  display: flex;
  flex-direction: column
}

.edit-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  color: var(--t1)
}

.edit-body {
  padding: 4px 16px 8px;
  overflow-y: auto;
  min-height: 0
}

.edit-foot {
  display: flex;
  gap: 10px;
  padding: 10px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid var(--line)
}

.edit-foot .btn {
  flex: 1;
  height: 44px;
  border-radius: 22px;
  font-size: 15px
}

.edit-foot .btn.ghost {
  background: #fff;
  color: var(--t2);
  border-color: #e0e4ec
}

.edit-body .fld > label em {
  color: var(--danger);
  font-style: normal
}

.edit-body .pv {
  min-height: 46px;
  display: flex;
  align-items: center;
  padding: 0 13px;
  background: var(--bg);
  border-radius: 11px;
  font-size: 15px;
  color: var(--t3);
  line-height: 1.5
}

.edit-body .fld .in {
  position: relative;
  display: flex;
  align-items: center
}

.edit-body .fld input {
  flex: 1;
  width: 100%;
  height: 46px;
  background: var(--bg);
  border-radius: 11px;
  padding: 0 13px;
  font-size: 15px;
  color: var(--t1);
  border: 1.5px solid transparent;
  outline: none;
  transition: .15s
}

.edit-body .fld input:focus {
  border-color: var(--primary);
  background: #fff;
  box-shadow: 0 0 0 3px var(--primary-l)
}

.edit-body .fld.err input {
  border-color: var(--danger);
  background: var(--danger-l)
}

.edit-body .fld .msg {
  font-size: 12px;
  color: var(--danger);
  margin-top: 5px;
  display: none
}

.edit-body .fld.err .msg {
  display: block
}

/* 驳回日志弹层 */
.rj-mask {
  position: fixed;
  inset: 0;
  background: rgba(12, 16, 22, .45);
  z-index: 100;
  display: flex;
  align-items: flex-end
}

.rj-panel {
  width: 100%;
  background: #fff;
  border-radius: 18px 18px 0 0;
  max-height: 86%;
  display: flex;
  flex-direction: column;
  padding-bottom: env(safe-area-inset-bottom)
}

.rj-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  position: relative;
  border-bottom: .5px solid var(--line)
}

.rj-body {
  padding: 16px;
  overflow-y: auto
}

.rj-empty {
  text-align: center;
  color: var(--t3);
  font-size: 13.5px;
  padding: 20px 0
}

.rj-cap {
  font-size: 12px;
  color: var(--t3);
  margin-bottom: 10px
}

.rj-log {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 11px 12px;
  margin-bottom: 10px
}

.rj-log:last-child {
  margin-bottom: 0
}

.rj-log-hd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px
}

.rj-idx {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--primary-d)
}

.rj-time {
  font-size: 12.5px;
  color: var(--t2);
  font-family: ui-monospace, Menlo, Consolas, monospace
}

.rj-line {
  display: flex;
  font-size: 13.5px;
  padding: 4px 0;
  line-height: 1.6
}

.rj-line .k {
  width: 64px;
  color: var(--t3);
  flex: none
}

.rj-line .v {
  flex: 1;
  color: var(--t1)
}

.rj-reason {
  margin-top: 4px
}

.rj-reason .k {
  display: block;
  font-size: 12.5px;
  color: var(--t3);
  margin-bottom: 4px
}

.rj-box {
  background: var(--danger-l);
  border-radius: 10px;
  padding: 11px 12px;
  font-size: 13.5px;
  color: #b8362e;
  line-height: 1.7;
  margin-top: 6px
}

.rj-foot {
  display: flex;
  padding: 10px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid var(--line)
}

.rj-foot .btn {
  flex: 1;
  height: 44px;
  border-radius: 22px;
  font-size: 15px
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: opacity .25s
}

.slide-up-enter-active .filter-panel, .slide-up-leave-active .filter-panel,
.slide-up-enter-active .rj-panel, .slide-up-leave-active .rj-panel,
.slide-up-enter-active .edit-panel, .slide-up-leave-active .edit-panel {
  transition: transform .3s cubic-bezier(.32, .72, 0, 1)
}

.slide-up-enter, .slide-up-leave-to {
  opacity: 0
}

.slide-up-enter .filter-panel, .slide-up-leave-to .filter-panel,
.slide-up-enter .rj-panel, .slide-up-leave-to .rj-panel,
.slide-up-enter .edit-panel, .slide-up-leave-to .edit-panel {
  transform: translateY(102%)
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MOrder.vue